import React from 'react';
import PropTypes from 'prop-types';
import { NavigationButton } from 'web-ui-components/lib/navigation/buttons';
import { StatusBanner } from 'web-ui-components/lib/layout/content';
import { StandardBody } from 'web-ui-components/lib/typography/body';

const VerificationAlert = ({
  onClose,
  isOpen,
  navigatePaymentStatus,
  numberOfVerifications,
  content = {
    authorisationAlertPluralMsg: '',
    authorisationAlertSingularMsg: '',
    authorisationAlertPluralAnchorBody: '',
    authorisationAlertSingularAnchorBody: '',
  },
}) => {
  const alertMsg =
    numberOfVerifications > 1
      ? content.authorisationAlertPluralMsg
      : content.authorisationAlertSingularMsg;
  const anchorBody =
    numberOfVerifications > 1
      ? content.authorisationAlertPluralAnchorBody
      : content.authorisationAlertSingularAnchorBody;
  return (
    <StatusBanner.Information onClose={onClose} isOpen={isOpen}>
      <StandardBody data-test-id="verification-alert-banner" isFlush>
        <span>
          {`${alertMsg} `}
          <NavigationButton.Tertiary
            labelText={anchorBody}
            onClick={navigatePaymentStatus}
            isInline
          />
        </span>
      </StandardBody>
    </StatusBanner.Information>
  );
};
VerificationAlert.propTypes = {
  onClose: PropTypes.func.isRequired,
  navigatePaymentStatus: PropTypes.func.isRequired,
  numberOfVerifications: PropTypes.number.isRequired,
  content: PropTypes.shape({
    authorisationAlertSingularMsg: PropTypes.string.isRequired,
    authorisationAlertPluralMsg: PropTypes.string.isRequired,
    authorisationAlertSingularAnchorMsg: PropTypes.string.isRequired,
    authorisationAlertPluralAnchorMsg: PropTypes.string.isRequired,
  }),
};

export default VerificationAlert;
